import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Pages/Login";
import IngresoAdmin from "./Pages/IngresoAdmin";
import Principal from "./Pages/Principal";
import ListaUsuarios from "./Pages/ListaUsuarios";
import CrearUsuarios from "./Pages/CrearUsuarios";
import VerUsuario from "./Pages/VerUsuario";

import Ingreso from "./Pages/Ingreso";
import ListaClientes from "./Pages/ListaClientes";
import ListaCuentas from "./Pages/ListaCuentas";
import ListaDesactivados from "./Pages/ListaDesactivados";
import ListaEliminarCliente from "./Pages/ListaEliminarCliente";
import ListaEliminarCuenta from "./Pages/ListaEliminarCuenta";
import ReporteDiario from "./Pages/ReporteDiario";
import UltimoLugarRegistrado from "./Pages/UltimoLugarRegistrado";
import PosicionClientes from "./Pages/PosicionClientes";
import ListasPersonalizadas from "./Pages/ListasPersonalizadas";
import FiltroClientes from "./Pages/FiltroClientes";
import EnviarMensaje from "./Pages/EnviarMensaje";
import NotasCobro from "./Pages/NotasCobro";
import NotasCobroSocio from "./Pages/NotasCobroSocio";
import NuevaLiquidacion from "./Pages/NuevaLiquidacion";
import ListaLiquidadas from "./Pages/ListaLiquidadas";
import SolicitudModificarCliente from "./Pages/SolicitudModificarCliente";
import SolicitudGastos from "./Pages/SolicitudGastos";
import ConfigurarUsuarios from "./Pages/ConfigurarUsuarios";
import ConfigurarSupervisor from "./Pages/ConfigurarSupervisor";
import ConfigurarCobrador from "./Pages/ConfigurarCobrador";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/ingresoadmin" element={<IngresoAdmin />} />
   
        <Route path="/principal" element={<Principal />} />
        <Route path="/ListaUsuarios" element={<ListaUsuarios />} />
         <Route path="/CrearUsuarios" element={<CrearUsuarios />} />
      <Route path="/verusuario/:id" element={<VerUsuario />} />

           <Route path="/ingreso" element={<Ingreso />} />
            <Route path="/listaclientes" element={<ListaClientes />} />
              <Route path="/listacuentas" element={<ListaCuentas />} />
                   <Route path="/listadesactivados" element={<ListaDesactivados />} />
                    <Route path="/listaeliminarcliente" element={<ListaEliminarCliente />} />
                     <Route path="/listaeliminarcuenta" element={<ListaEliminarCuenta />} />
                       <Route path="/listaspersonalizadas" element={<ListasPersonalizadas />} />
                         <Route path="/filtroclientes" element={<FiltroClientes />} />
                           <Route path="/listaspersonalizadas" element={<ListasPersonalizadas />} />
                     <Route path="/reportediario" element={<ReporteDiario />} />
                       <Route path="/ultimolugarregistrado" element={<UltimoLugarRegistrado/>} />
                         <Route path="/posicionclientes" element={<PosicionClientes />} />
                           <Route path="/enviarmensaje" element={<EnviarMensaje />} />
                             <Route path="/notascobro" element={<NotasCobro />} />
                               <Route path="/notascobrosocio" element={<NotasCobroSocio />} />
                                 <Route path="/nuevaliquidacion" element={<NuevaLiquidacion />} />
                                   <Route path="/listaliquidadas" element={<ListaLiquidadas />} />
                                     <Route path="/solicitudmodificarcliente" element={<SolicitudModificarCliente />} />
                                       <Route path="/solicitudgastos" element={<SolicitudGastos/>} />
                                       <Route path="/configurarusuarios" element={<ConfigurarUsuarios/>} />
                                      
                                       <Route path="/configurarsupervisor/:id" element={<ConfigurarSupervisor />}/>
                                       <Route path="/configurarcobrador/:id" element={<ConfigurarCobrador />}/>
      </Routes>
    </Router>
  );
}

export default App;
